import React from 'react';

import { ApolloProvider } from 'react-apollo';

// Browser routing
import { BrowserRouter } from 'react-router-dom';
import { MuiThemeProvider } from 'components';

import injectTapEventPlugin from 'react-tap-event-plugin';
import { init as initLogRocket } from 'util/logger';

import apolloClient from './apolloClient';

import GAListener from './GAListener';

import Header from './Header';
import RootRoutes from './RootRoutes';

import theme from './theme';

initLogRocket();
// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

const StackStackApp = () =>
  <ApolloProvider client={apolloClient}>
    <BrowserRouter>
      <GAListener>
        <MuiThemeProvider theme={theme}>
          <div className="StackStackApp">
            <Header />
            <RootRoutes />
          </div>
        </MuiThemeProvider>
      </GAListener>
    </BrowserRouter>
  </ApolloProvider>;

export default StackStackApp;



// WEBPACK FOOTER //
// ./src/App/index.js